package one.healthium.onboarding.domain.configs

import kotlinx.serialization.Serializable

@Serializable
sealed interface ScreenConfig
